export default __webpack_public_path__ + "static/media/hero.6ade9716.png";